<template>
  <validation-provider
    v-slot="{ errors }"
    :rules="rulesText"
    :name="name"
    :mode="mode">
    <slot />
    <div class="form-guide">
      {{ errors[0] }}
    </div>
  </validation-provider>
</template>

<script>
import { join, isArray, includes } from 'lodash';
import { ValidationProvider } from 'vee-validate';
export default {
  name: 'Validator',
  component: {
    ValidationProvider,
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    rules: {
      type: [String, Array],
      default: () => ['required'],
    },
    mode: {
      type: String,
      validator: (val) => includes(['aggressive', 'passive', 'lazy', 'eager'], val),
      default: 'eager',
    },
  },
  computed: {
    rulesText() {
      if (isArray(this.rules)) {
        return join(this.rules, '|');
      }
      return this.rules;
    },
  },
};
</script>

<style scoped>

</style>
